import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import RoomInstance from "./RoomInstance";
import { ROOM_CALL_STATE } from "./RoomInstance";
import { Peer } from "peerjs";

class RoomPeer{

    private conquer: CONQUER;
    private roomInstance: RoomInstance;
    private peer: Peer|undefined;

    private connection:any;
    private incomingCall:any;
    private videoAsked: boolean = false;
    
    public localStream:any = false;
    public remoteStream:any = false;

    public state:string = '';
    public isConnected: boolean = false;
    public isCreated: boolean = false;

    private connectedPeer:any;

    private fakeDrawTimeout:any;
    private fakeCanvas:any = document.createElement('canvas');
    public messageHandler: Function = function(e:any){};

    constructor( conquer:CONQUER ){

        this.conquer = conquer;

    }

    public async startCall(): Promise<any>
    {

        if( !this.connection ) return this.roomInstance.setCallState( ROOM_CALL_STATE.CALLING );

        if( !this.peer || !this.connection ) return console.log( 'CANT CALL, IS NOT CONNECTED' );
        if( !this.roomInstance.RIVAL && !this.connectedPeer ) return console.log( 'CANT CALL, NO ONE IS CONNECTED' );

        this.roomInstance.setCallState( ROOM_CALL_STATE.WAITING_PERMISSIONS );

        await this.addStreamTracks({audio: true}).then(() => {

            if( !this.localStream ) return this.answerCall(false);

            let peer = this.roomInstance.RIVAL?.avatarID || this.connectedPeer;

            let call = this.peer?.call(peer, this.localStream);
            this.incomingCall = call;
            this.initializeCall( call );

            this.roomInstance.setCallState( ROOM_CALL_STATE.CALLING );

        });

        return Promise.resolve();

    }

    public async answerCall( accept: boolean ): Promise<any>
    {

        if( !accept ){

            this.roomInstance?.setCallState( ROOM_CALL_STATE.IDLE );
            this.clear();
            await this.roomInstance?.doSend( ACTIONS.REJECT_CALL );
            return;

        }

        if( !this.peer || !this.incomingCall ) return;

        let newStream = await this.addStreamTracks({audio: true});

        if( !newStream) return this.answerCall(false);

        this.initializeCall( this.incomingCall );
        await this.incomingCall.answer( this.localStream );

    }

    public assignRoom( roomInstance ){

        this.roomInstance = roomInstance;

        if( !roomInstance ) return;
        
        this.conquer.Signal.get( this.roomInstance.eventsKey + ':onChat', (message:any) => { this.onMessageReceived(message)  });

    }

    public createConnection(){

        if( this.isCreated ) return;

        this.peer = new Peer( this.roomInstance?.ME.avatarID, {
            // host: "nowwa.io",
            // port: 9010,
            // path: "/systems/chatpeer",
            config: 
            {
                'iceServers': [
                    { url: "stun:stun01.sipphone.com" },
                    { url: "stun:stun.ekiga.net" },
                    { url: "stun:stun.fwdnet.net" },
                    { url: "stun:stun.ideasip.com" },
                    { url: "stun:stun.iptel.org" },
                    { url: "stun:stun.rixtelecom.se" },
                    { url: "stun:stun.schlund.de" },
                    { url: "stun:stun.l.google.com:19302" },
                    { url: "stun:stun1.l.google.com:19302" },
                    { url: "stun:stun2.l.google.com:19302" },
                    { url: "stun:stun3.l.google.com:19302" },
                    { url: "stun:stun4.l.google.com:19302" },
                    { url: "stun:stunserver.org" },
                    { url: "stun:stun.softjoys.com" },
                    { url: "stun:stun.voiparound.com" },
                    { url: "stun:stun.voipbuster.com" },
                    { url: "stun:stun.voipstunt.com" },
                    { url: "stun:stun.voxgratia.org" },
                    { url: "stun:stun.xten.com" },
                ],
            },
            debug: 3,
            // secure: true
        } );

        this.peer.on( "connection", (conn:any) => { this.initializeConnection( conn ); } );
        this.peer.on( 'error', (err:any) => { console.log('ERROR:', err); this.clear(); } );

        this.isCreated = true;

    }

    public disconnect(){

        this.clear();

    }

    private initializeConnection( conn:any ){

        if( !conn ) return console.log('ERROR WHILE TRYING TO CONNECT:', conn);

        this.connection = conn;
        this.isConnected = true;

        this.connectedPeer = this.connection.peer;

        this.peer?.on('call', ( call:any ) => {

            this.roomInstance.setCallState( ROOM_CALL_STATE.RECEIVED );
            this.incomingCall = call;

         } );

        // this.connection.on('data', (data:any) => {

        //     console.log('MESSAGE',data);

        // });

    }

    public async startConnection(){
     
        this.connection = this.peer?.connect( this.roomInstance?.RIVAL.avatarID );
        this.initializeConnection( this.connection );

    }

    public async addStreamTracks( permissions: any ){

        let stream;
        await navigator.mediaDevices.getUserMedia( permissions ).then((newStream) =>{stream = newStream}).catch( (err:any) => { console.log('ERRORRRR', err); } );

        if( !stream ) return;

        this.localStream = stream;
        if( this.localStream.getVideoTracks().length == 0 ) this.localStream.addTrack( this.getDummy().getVideoTracks()[0] ); //Fake Video

        return stream;

    }

    private async initializeCall( call:any ){

        call?.on('stream',(stream:any) => {
    
            this.remoteStream = stream;
            if( this.roomInstance.callState !== ROOM_CALL_STATE.IN_PROGRESS ) this.roomInstance.setCallState( ROOM_CALL_STATE.IN_PROGRESS );

        } );

    }

    public async toggleMute(): Promise<any>
    {

        if( !this.connection ) return Promise.resolve();

        this.localStream.getAudioTracks().forEach((track:any) => track.enabled = !track.enabled);
        let isActive = this.localStream.getAudioTracks()[0].enabled;
        this.messageHandler?.( 'onLocalAudioStateChanged' , isActive );
        await this.roomInstance.doSend( ACTIONS.CHAT_MUTE_CHANGE, {isActive} );

        return Promise.resolve();

    }

    public async toggleCamera(): Promise<any>
    {
        
        if( !this.videoAsked ){

            let newStream = await this.addStreamTracks( {video: true, audio: true} );
            if( !newStream ) return;
            this.incomingCall.peerConnection.getSenders()[1].replaceTrack(newStream.getVideoTracks()[0])
            this.incomingCall.peerConnection.getSenders()[0].replaceTrack(newStream.getAudioTracks()[0])
            this.videoAsked = true;

        }else this.localStream.getVideoTracks().forEach((track:any) => track.enabled = !track.enabled);

        let isActive = this.localStream.getVideoTracks()[0].enabled && this.localStream;
        this.messageHandler?.( 'onLocalVideoStateChanged' , isActive );
        await this.roomInstance.doSend( ACTIONS.CHAT_VIDEO_CHANGE, { isActive }  );

    }

    private onMessageReceived( message : any ){

        if( message.action == ACTIONS.REJECT_CALL && this.roomInstance.callState != ROOM_CALL_STATE.IDLE ) this.answerCall( false );
        // if( message.action == ACTIONS.CALL || message.action == ACTIONS.ACCEPT_CALL ) this.onSignalResponse( message.data );
        // if( message.action == ACTIONS.CHAT_ICECANDIDATE ) this.receiveIceCandidate( message.data );
        if( message.action == ACTIONS.CHAT_VIDEO_CHANGE ) this.onVideoStateChanged( message.data );
        if( message.action == ACTIONS.CHAT_MUTE_CHANGE ) this.onMuteStateChanged( message.data );

    }

    private onMuteStateChanged( data:any ){

        this.remoteStream.getAudioTracks().forEach((track:any) => track.enabled = data.isActive);
        this.messageHandler?.( 'onAudioStateChanged' , data.isActive );

    }

    private onVideoStateChanged( data:any ){

        this.messageHandler?.( 'onVideoStateChanged' , data.isActive ? this.remoteStream : undefined );

    }

    private getDummy(){

        let audio = this.localStream.getAudioTracks()[0];
          
        const width:number = 640;
        const height:number = 480;
        const canvas = Object.assign(this.fakeCanvas, { width, height });
        canvas.getContext('2d')!.fillRect(0, 0, width, height);
        
        const stream = canvas.captureStream();
        const track = stream.getVideoTracks()[0];
        let black = Object.assign(track, { enabled: false });
          
        let blackSilence:any = new MediaStream([audio, black ]);

        let draw = () => {
            canvas.getContext('2d')!.fillRect(0, 0, width, height);
            this.fakeDrawTimeout = setTimeout( draw, 10 );
        };

        clearTimeout(this.fakeDrawTimeout);
        draw();

        return blackSilence;

    }

    private clear(){

        if( this.incomingCall ) this.incomingCall.close();
        this.incomingCall = false;

        this.videoAsked = false;
        this.isCreated = false;
        this.isConnected = false;

        this.roomInstance?.setCallState( ROOM_CALL_STATE.IDLE );

        if( this.localStream ) this.localStream.getTracks().forEach(function(track:any) {
            track.stop();
        });

        if( this.remoteStream ) this.remoteStream.getTracks().forEach(function(track:any) {
            track.stop();
        });

    }

}

export default RoomPeer;